import React, { useEffect, useState } from "react";
import useThemeColors from "../../vehicle/ThemeColors";
import { useCreateServiceMasterMutation } from "../../../Services/inventory/Inventory";
import { toast } from "react-toastify";
import {
  useGetAllFuelTypeDataQuery,
  useGetBrandDataQuery,
  useGetIdModelDataQuery,
  useGetServiceDataQuery,
  useGetSubServiceOnIdBasisDataQuery,
} from "../../../Services/vehicle/Vehicle";
import { WORKSHOP_ID } from "../../../constants";
import { Loader } from "react-bootstrap-typeahead";
import ReactQuill from "react-quill";

interface IPROPS {
  closeModal: any;
  refetch: any;
}

const AddServiceMaster: React.FC<IPROPS> = ({ closeModal, refetch }) => {

  const [modelId, setModelId] = useState<any>("");
  const [brandId, setBrandId] = useState<any>("");
  const [fuelTypeId, setFuelTypeId] = useState<any>("");
  const [serviceTypeId, setServiceTypeId] = useState<any>("");
  const [subServiceTypeId, setSubServiceTypeId] = useState<any>("");
  const [desc, setDesc] = useState("");
  const [vehicleTableData, setVehicleTableData] = useState([]);
  const [carModelData, setCarModelData] = useState([]);
  const [fuelTableData, setFuelTableData] = useState([]);
  const [serviceTableData, setServiceTableData] = useState([]);
  const [subServiceTableData, setSubServiceTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);

  const [createMasterLoader, setCreateMasterLoader] = useState(false);
  const [createServiceMasterTrigger, { status: serviceMasterLoader }] =
    useCreateServiceMasterMutation();

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
  ];

  useEffect(() => {
    if (serviceMasterLoader === "pending") {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [serviceMasterLoader]);

  // Brand
  const { data: vehicleData, status, isLoading } = useGetBrandDataQuery({});

  // Model
  const {
    data: modelData,
    status: modelStatus,
    refetch: modelRefetch,
    isLoading: modelLoading,
  } = useGetIdModelDataQuery(brandId);

  // Fuel type
  const { data: fuelData } = useGetAllFuelTypeDataQuery({});

  // Service
  const { data: serviceData } = useGetServiceDataQuery({});

  // Sub service
  const { data: subServiceData } =
    useGetSubServiceOnIdBasisDataQuery(serviceTypeId);

  useEffect(() => {
    if (subServiceData) {
      setSubServiceTableData(subServiceData);
    }
  }, [subServiceData]);

  useEffect(() => {
    // --- Updated logic for handling multiple data shapes ---
    if (vehicleData) {
      if (Array.isArray(vehicleData)) {
        setVehicleTableData(vehicleData);
      } else if (vehicleData?.results) {
        setVehicleTableData(vehicleData.results);
      } else {
        setVehicleTableData([]);
      }
    }
  }, [vehicleData]);

  useEffect(() => {
    if (modelData) {
      if (Array.isArray(modelData)) {
        setCarModelData(modelData);
      } else if (modelData?.results) {
        setCarModelData(modelData.results);
      } else {
        setCarModelData([]);
      }
    }
  }, [modelData]);

  useEffect(() => {
    if (fuelData) {
      if (Array.isArray(fuelData)) {
        setFuelTableData(fuelData);
      } else if (fuelData?.results) {
        setFuelTableData(fuelData.results);
      } else {
        setFuelTableData([]);
      }
    }
  }, [fuelData]);

  useEffect(() => {
    if (serviceData) {
      if (Array.isArray(serviceData)) {
        setServiceTableData(serviceData);
      } else if (serviceData?.results) {
        setServiceTableData(serviceData.results);
      } else {
        setServiceTableData([]);
      }
    }
  }, [serviceData]);

  useEffect(() => {
    if (status === "pending") {
      setCreateMasterLoader(true);
    } else {
      setCreateMasterLoader(false);
    }
  }, [status]);

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const saveConsentMaster = async () => {
    const payload = {
      workshop: getWorkshopId,
      brand: brandId,
      model: modelId,
      fuel_type: fuelTypeId,
      service_type: serviceTypeId,
      sub_service_type: subServiceTypeId,
      labour_cost: 1,
      price: 1,
      description: desc,
    };
    const response = await createServiceMasterTrigger(payload);

    try {
      if (response?.data) {
        closeModal();
        toast.success("Service added successfully");
        refetch();
      } else if (response?.error) {
        toast.error("An error occured");
      }
    } catch (error) {
      toast.error("An error occured");
    }
  };

  return (
    <div>
      <div className="vehicle-info-middle">
        <div
          className="vehicle-info-middle-heading"
          style={{
            borderBottom: "1px solid #C7C8CA",
            padding: "15px 30px",
            fontSize: "20px",
            color: "#6C6D70",
            fontFamily: "karbon",
          }}
        >
          Service Master
        </div>
        <div
          className="vehicle-info"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "10px 15px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "10px",
              padding: "10px 30px",
            }}
          >
            {/* Brand Dropdown */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    color: "#6C6D70",
                    fontSize: "13px",
                    fontFamily: "karbon",
                  }}
                >
                  Brand
                </span>
                <span>
                  <select
                    value={brandId}
                    onChange={(e) => setBrandId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      color: "#6C6D70",
                      fontFamily: "karbon",
                    }}
                  >
                    <option style={{ color: "#6C6D70", fontFamily: "karbon" }}>
                      Select an option
                    </option>
                    {vehicleTableData &&
                      vehicleTableData.map((brand: any) => (
                        <option
                          key={brand.id}
                          value={brand.id}
                          style={{ color: "#6C6D70", fontFamily: "karbon" }}
                        >
                          {brand.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>

            {/* Model Dropdown */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    color: "#6C6D70",
                    fontSize: "13px",
                    fontFamily: "karbon",
                  }}
                >
                  Model
                </span>
                <span>
                  <select
                    disabled={!brandId}
                    value={modelId}
                    onChange={(e) => setModelId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      color: "#6C6D70",
                      fontFamily: "karbon",
                    }}
                  >
                    <option style={{ color: "#6C6D70", fontFamily: "karbon" }}>
                      Select an option
                    </option>
                    {carModelData &&
                      carModelData.map((model: any) => (
                        <option
                          key={model.id}
                          value={model.id}
                          style={{ color: "#6C6D70", fontFamily: "karbon" }}
                        >
                          {model?.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>

            {/* Fuel type Dropdown */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    color: "#6C6D70",
                    fontFamily: "karbon",
                  }}
                >
                  Fuel type
                </span>
                <span>
                  <select
                    value={fuelTypeId}
                    onChange={(e) => setFuelTypeId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      color: "#6C6D70",
                      fontFamily: "karbon",
                    }}
                  >
                    <option style={{ color: "#6C6D70", fontFamily: "karbon" }}>
                      Select an option
                    </option>
                    {fuelTableData &&
                      fuelTableData.map((fuelType: any) => (
                        <option
                          key={fuelType.id}
                          value={fuelType.id}
                          style={{ color: "#6C6D70", fontFamily: "karbon" }}
                        >
                          {fuelType.type}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>

            {/* Service Dropdown */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    color: "#6C6D70",
                    fontFamily: "karbon",
                  }}
                >
                  Service type
                </span>
                <span>
                  <select
                    value={serviceTypeId}
                    onChange={(e) => setServiceTypeId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      color: "#6C6D70",
                      fontFamily: "karbon",
                    }}
                  >
                    <option style={{ color: "#6C6D70", fontFamily: "karbon" }}>
                      Select an option
                    </option>
                    {serviceTableData &&
                      serviceTableData.map((service: any) => (
                        <option
                          key={service.id}
                          value={service.id}
                          style={{ color: "#6C6D70", fontFamily: "karbon" }}
                        >
                          {service.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>

            {/* Sub service Dropdown */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    color: "#6C6D70",
                    fontFamily: "karbon",
                  }}
                >
                  Sub service
                </span>
                <span>
                  <select
                    value={subServiceTypeId}
                    onChange={(e) => setSubServiceTypeId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      color: "#6C6D70",
                      fontFamily: "karbon",
                    }}
                  >
                    <option style={{ color: "#6C6D70", fontFamily: "karbon" }}>
                      Select an option
                    </option>
                    {subServiceTableData &&
                      subServiceTableData.map((subService: any) => (
                        <option
                          key={subService.id}
                          value={subService.id}
                          style={{ color: "#6C6D70", fontFamily: "karbon" }}
                        >
                          {subService.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>
          </div>
          <div style={{ padding: "10px 30px" }}>
            <ReactQuill
              theme="snow"
              value={desc}
              onChange={setDesc}
              modules={modules}
              formats={formats}
              style={{ borderRadius: "20px" }}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              onClick={saveConsentMaster}
              style={{
                background: `${selectedButtonBackgoundColors}`,
                color: `${selectedButtonColors}`,
                border: "none",
                padding: "10px 20px",
                borderRadius: "20px",
                fontSize: "13px",
                fontFamily: "karbon",
              }}
            >
              {loading ? (
                <>
                  Saving...
                  <Loader />
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddServiceMaster;
